import React from 'react';

import RichText from 'components/rich-text';
import VideoEmbed from 'components/video-embed';

import './style.css';

const Video = React.forwardRef((_, ref) => {
  return (
    <section className="video" ref={ref}>
      <h2 className="video-title">
        We’re here to help you keep the ball rolling.
      </h2>
      <div className="home-video-wrapper">
        <VideoEmbed className="home-video-embed" />
      </div>
      <RichText className="video-message">
        <p>
          After decades of combined experience in business consultancy, we’ve
          developed a system that has helped us grow our own companies. Now, we
          want to share that with you.
        </p>

        <p>
          Tweak+ is a method based on our expert analysis of what you tell us
          about your business. Our in-depth questionnaire helps us get to know
          your current obstructions in your business. We then interpret the
          answers you provide and identify exactly where you need to make
          adjustments.
        </p>

        <p id="video-start-circuit">
          small changes can lead to a gigantic difference.
        </p>
      </RichText>
      <div id="hero-end-02-circuit" className="target" />
    </section>
  );
});

export default Video;
